import { FinanceContract as FinanceContractType } from 'cpes-common';
import { Card } from '@vwfs-bronson/bronson-react';
import { ContractHeader } from 'components/contracts/ContractHeader';
import React from 'react';

export type RequestCertificateHeaderProps = {
    contract: FinanceContractType;
};

export const RequestCertificateHeader: React.FC<RequestCertificateHeaderProps> = ({ contract }) => {
    return (
        <Card title="">
            <ContractHeader contract={contract} />
        </Card>
    );
};
